export enum ReportStep {
    INITIAL = 'INITIAL',
    REASON = 'REASON',
    BLOCK = 'BLOCK',
    SUCCESS = 'SUCCESS',
}
